<template lang="pug">
	.fondoModal
			div
				div
					.card.text-left
						.card-header(:class="(sinAgente) ? 'bg-danger text-white' : ''")
							| Editor de contratos
							span(style="font-weight:bolder;" v-if="sinAgente")
								span.fa.fa-exclamation-triangle.ml-2.mr-2
								| Contrato sin agente
							button.close(type="button" aria-label="Close" @click="cerrar")
								span(aria-hidden="true") ×
						.filaGris
							.row
								.col-xs-12.col-sm-4.col-md-4.col-lg-4
									.form-group
										label Agente
										.input-group(v-if="permisos.contratos_crearAjenos")
											.input-group-prepend
												span.input-group-text.fa.fa-user
											input-query(v-if="!contrato.agente && !sinAgente" placeholder="Busca por agente" input-class="form-control" :realtime="true" url="mis-contratos/php/api/buscaAgente.php" @selected="seleccionaAgente($event)")
											input.form-control(v-if="contrato.agente" type="text" disabled="" :value="contrato.nombreAgente")
											.input-group-append(v-if="contrato.agente && !contrato.antiguo")
												button.btn.btn-xs.btn-danger(@click="cambiaAgente()")
													span.fa.fa-trash
											input.form-control(type="text" disabled="" value="Contrato sin agente" v-if="sinAgente")
											.input-group-append(v-if="permisos.contratos_crearContratosSinAgente")
												button.btn(:class="(sinAgente) ? 'btn-danger' : 'btn-success'" @click="sinAgente = !sinAgente")
													span.fa.fa-toggle-on(v-if="!sinAgente")
													span.fa.fa-toggle-off(v-if="sinAgente")
										input.form-control-sm.form-control(type="text" disabled="" :value="usuario.nombre" v-if="!permisos.contratos_crearAjenos")
								.col-xs-12.col-sm-4.col-md-4.col-lg-4
									.form-group
										label Cliente
										.input-group.input-group-sm
											.input-group-prepend
												span.input-group-text.fa.fa-user
											input-query(:disabled="!contrato.agente && !sinAgente" v-if="!contrato.cliente" placeholder="Busca por cliente" input-class="form-control" :realtime="true" :url="'mis-contratos/php/api/buscaCliente.php?agente=' + contrato.agente" @selected="seleccionaCliente($event)")
											input.form-control.form-control-sm(v-if="contrato.cliente" type="text" disabled="" :value="contrato.nombreCliente")
											.input-group-btn(v-if="contrato.cliente && !contrato.antiguo")
												button.btn.btn-xs.btn-danger(@click="cambiaCliente()")
													span.fa.fa-trash
								.col-xs-12.col-sm-4.col-md-4.col-lg-4
									.form-group.form-group-sm
										label Facturar a 
										select.form-control.form-control-sm(@change="setDestino($event)" v-if="!contrato.destino")
											option(:value="null") Selecciona
											option(:value="destino.ID_destino" v-for="destino in listadoDestinos") {{ destino.nombre }}
										.input-group.input-group-sm(v-if="contrato.destino")
											input.form-control.form-control-sm(type="text" disabled="" :value="contrato.nombreDestino")
											.input-group-btn
												button.btn.btn-danger.btn-xs(@click="contrato.destino = null")
													span.fa.fa-trash
						.card-body(v-if="contrato.cliente && contrato.destino")
							.row
								.col-xs-12.col-sm-3.col-md-3.col-lg-3
									.form-group
										label(for="") Título de la campaña
										input.form-control.form-control-sm(type="text" name="" :disabled="contrato.antiguo" v-model="contrato.titulo")
								.col-xs-12.col-sm-3.col-md-3.col-lg-3
									.form-group
										label(for="") Fecha de inicio
										datepicker(input-class="form-control form-control-sm" :language='$dateLang' :monday-first="true" :disabled-picker="contrato.antiguo" v-model="contrato.fecha_inicio")
								.col-xs-12.col-sm-3.col-md-3.col-lg-3
									.form-group
										label(for="") Fecha de finalización
										datepicker(input-class="form-control form-control-sm" :language='$dateLang' :monday-first="true" :disabled-picker="contrato.antiguo" v-model="contrato.fecha_fin")
								.col-xs-12.col-sm-3.col-md-3.col-lg-3
									.form-group
										label(for="") Descuento global
										input.form-control.form-control-sm(type="number" v-model.number="contrato.dto_global" placeholder="0")
							hr
							.row
								.col-xs-12.col-sm-4.col-md-4.col-lg-4
									.form-group
										label(for="") Partida
										select.form-control.form-control-sm(:disabled="contrato.antiguo" v-model="contrato.partida")
											option(:value="null") Selecciona una partida
											option(:value="partida.ID_partida" v-for="partida in listadoPartidas") {{ partida.titulo }}
								.col-xs-12.col-sm-4.col-md-4.col-lg-4
									.form-group
										label(for="") Evento
										select.form-control.form-control-sm(:disabled="contrato.antiguo" v-model="contrato.evento")
											option(:value="null") Selecciona un evento
											option(:value="evento.ID_evento" v-for="evento in listadoEventos") {{ evento.titulo }}
								.col-xs-12.col-sm-4.col-md-4.col-lg-4
									div(v-if="permisos.contratos_seleccionarIntermediarios")
										.form-group.from-group-sm
											label(for="") Intermediario
											.input-group(v-if="!creandoIntermediario && !contrato.intermediario")
												input-query(placeholder="Busca un intermediario" input-class="form-control form-control-sm" :realtime="true" :url="'mis-contratos/php/api/buscaIntermediario.php'" @selected="seleccionaIntermediario($event)")
												.input-group-append
													button.btn.btn-sm.btn-warning(@click="creandoIntermediario = true")
														span.fa.fa-plus
											.input-group(v-if="creandoIntermediario")
												input.form-control.form-control-sm(type="text" placeholder="Escribe el nombre y pulsa intro" v-model="nuevoIntermediario" @keypress.enter="crearIntermediario()")
												.input-group-append
													button.btn.btn-sm.btn-danger(@click="creandoIntermediario = false")
														span.fa.fa-close
											.input-group(v-if="contrato.intermediario")
												input.form-control(type="text" disabled="" v-model="contrato.intermediarioNombre")
												.input-group-btn
													button.btn.btn-sm.btn-danger(@click="contrato.intermediario = null")
														span.fa.fa-trash
						.alert.alert-info(style="border-radius: 0;" v-if="contrato.cliente && !contrato.antiguo && contrato.destino")
							.pull-right
								button.btn.btn-sm.btn-primary(type="button" @click="nuevaLinea()")
									span.fa.fa-plus
							b Añade los productos
							br
							| A continuación puedes añadir los productos que va a contratar el cliente
						// Método anterior
							.table-responsive(v-if="contrato.lineas.length > 0 && contrato.cliente")
								table.table.table-striped(style="margin-bottom: 20px;")
									thead
										tr
											th Soporte
											th Producto
											th Tarifa
											th Cantidad
											th Dto
											th Forzado
											th Total
											th Pendiente
									tbody
										tr(v-for="(linea, index) in contrato.lineas")
											td
												div(v-if="!linea.soporte")
													select.form-control.form-control-sm(@change="seleccionaSoporte(linea, $event)")
														option(:value="null") Selecciona
														option(:value="JSON.stringify(soporte)" v-for="soporte in listadoSoportes") {{ soporte.soporte }}
												.input-group.input-group-sm(v-if="linea.soporte")
													input.form-control.form-control-sm(type="text" disabled="" :value="linea.nombreSoporte")
													.input-group-btn(v-if="!contrato.antiguo")
														button.btn.btn-xs.btn-warning(@click="quitaSoporte(linea)")
															span.fa.fa-trash
											td
												div(v-if="!linea.producto")
													select.form-control.form-control-sm(:disabled="!linea.soporte" @change="seleccionaProducto(linea, $event)")
														option(:value="null") Selecciona
														option(:value="JSON.stringify(producto)" v-for="producto in listadoProductos[contrato.lineas[index].soporte]") {{ producto.nombre }}
												.input-group.input-group-sm(v-if="linea.producto")
													input.form-control.form-control-sm(type="text" :value="linea.nombreProducto" disabled="")
													.input-group-btn(v-if="!contrato.antiguo")
														button.btn.btn-warning.btn-xs(@click="quitaProducto(linea)")
															span.fa.fa-trash
											td
												div(v-if="!linea.tarifa")
													select.form-control.form-control-sm(:disabled="!linea.producto" @change="seleccionaTarifa(linea, $event)")
														option(:value="null") Selecciona
														optgroup(:label="index" v-for="(ano, index) in listadoTarifas[linea.producto]")
															option(:value="JSON.stringify(tarifa)" v-for="tarifa in ano")
																| {{ tarifa.duracion }} {{ tarifa.unidades }} ({{ tarifa.precio_unitario * tarifa.duracion | currency('€')}})
												.input-group.input-group-sm(v-if="linea.tarifa")
													input.form-control.form-control-sm(type="text" disabled="" :value="linea.duracion + ' ' + linea.unidades")
													.input-group-btn(v-if="!contrato.antiguo")
														button.btn.btn-xs.btn-warning(@click="quitaTarifa(linea)")
															span.fa.fa-trash
											td
												input.form-control.form-control-sm(style="width:80px;" :disabled="contrato.antiguo || !linea.tarifa" type="number" name="" v-model.number="contrato.lineas[index].cantidad" placeholder="0")
											td
												input.form-control.form-control-sm(v-if="!linea.precio_trucado" :disabled="contrato.antiguo || !linea.cantidad" style="width:80px;" type="number" name="" v-model="contrato.lineas[index].descuento" placeholder="0")
												input.form-control.form-control-sm(v-if="linea.precio_trucado" style="width:80px;" disabled="" type="number" name="" v-model="contrato.lineas[index].descuentoForzado" placeholder="0")
											td
												input.form-control.form-control-sm(style="width:80px;" :disabled="contrato.antiguo || !linea.cantidad" type="number" name="" v-model="contrato.lineas[index].precio_trucado" placeholder="0")
											td
												| {{ getImporte(linea) | currency('€')}}
											td(style="min-width:150px;")
												.btn-group(v-if="!contrato.antiguo")
													button.btn.btn-sm.btn-danger(type="button" @click="abrirFacturacion('radio', linea)")
														| {{ calculaPagos(linea) | currency('€') }}
													button.btn.btn-sm.btn-warning(@click="quitaLinea(index, linea)")
														span.fa.fa-trash
												div(v-if="contrato.antiguo")
													button.btn.btn-sm.btn-warning(@click="alertaAntiguo()")
														span.fa.fa-warning-sign
						// Método nuevo
						.contieneLineasTarifas
							.lineaTarifa(v-if="contrato.lineas.length > 0")
								.celdaDescripcion Descripción
								.celdaCantidad Cantidad
								.celdaDto Descuento
								.celdaForzado P. trucado
								.celdaImporte Importe
								.celdaDistribuir
							.lineaTarifa(v-for="(linea, index) in contrato.lineas")
								.celdaDescripcion
									input-query(v-if="!linea.tarifa", url="/mis-contratos/php/api/busca-productos.php", :realtime="true", inputClass="form-control", @selected="seleccionaTarifaNueva(contrato.lineas[index], $event)")
									.input-group(v-if="linea.tarifa")
										input.form-control(type="text", disabled="true", :value="linea.descripcion")
										.input-group-append
											button.btn.btn-danger(@click="contrato.lineas[index].tarifa = null")
												span.fa.fa-trash
								.celdaCantidad
									input.form-control(:disabled="!linea.tarifa", v-model="contrato.lineas[index].cantidad")
								.celdaDto
									input.form-control(:disabled="!linea.tarifa", v-model="contrato.lineas[index].descuento")
								.celdaForzado
									input.form-control(:disabled="!linea.tarifa || !linea.cantidad", v-model="contrato.lineas[index].precio_trucado")
								.celdaImporte
									| {{getImporte(linea) | currency('€')}}
								.celdaDistribuir
									.btn-group(v-if="!contrato.antiguo")
										button.btn.btn-sm.btn-danger(type="button" @click="abrirFacturacion('radio', linea)")
											| {{ calculaPagos(linea) | currency('€') }}
										button.btn.btn-sm.btn-warning(@click="quitaLinea(index, linea)")
											span.fa.fa-trash
						.alert.alert-success(style="border-radius: 0;" v-if="contrato.cliente && !contrato.antiguo && contrato.destino")
							.pull-right
								button.btn.btn-sm.btn-primary(type="button" @click="nuevoConcepto()")
									span.fa.fa-plus
							b Otros conceptos
							br
							| Puedes añadir otro tipo de conceptos, como recargo por producción, fijación horaria, etc.
						.table-responsive(v-if="contrato.lineasConceptos.length > 0 && contrato.cliente && !contrato.antiguo && contrato.destino")
							table.table.table-striped
								thead
									tr
										th(style="min-width: 300px;") Concepto
										th Soporte
										th Importe
										th Cantidad
										th Dto
										th Forzado
										th Total
										th Pendiente
								tbody
									tr(v-for="(item, index) in contrato.lineasConceptos")
										td
											input.form-control-sm.form-control(v-model="item.concepto" type="text" placeholder="Fijación horaria")
										td
											select.form-control.form-control-sm(:disabled="!item.concepto" v-model="contrato.lineasConceptos[index].soporte" name="")
												option(:value="null") Selecciona
												option(:value="soporte.ID_soporte" v-for="soporte in listadoSoportes") {{ soporte.soporte }}
										td
											input.form-control-sm.form-control(:disabled="!item.soporte" v-model="item.precio_unitario" type="number" placeholder="60")
										td
											input.form-control-sm.form-control(:disabled="!item.precio_unitario" v-model="item.cantidad" type="number" placeholder="1")
										td
											input.form-control-sm.form-control(:disabled="!item.cantidad" v-if="!item.precio_trucado" v-model="item.descuento" type="number" placeholder="20")
											input.form-control-sm.form-control(v-if="item.precio_trucado" disabled="" :value="calculaDescuentoConcepto(item)" type="number" placeholder="20")
										td
											input.form-control-sm.form-control(:disabled="!item.cantidad" v-model="item.precio_trucado" type="number")
										td {{ getImporteConcepto(item) | currency('€') }}
										td(style="min-width:150px;")
											.btn-group
												button.btn.btn-sm.btn-danger(type="button" @click="abrirFacturacion('otros', item)")
													| {{ calculaPagos(item) | currency('€') }}
												button.btn.btn-sm.btn-warning(@click="quitaLinea(index, item)")
													span.fa.fa-trash
						.card-body(v-if="contrato.cliente && !contrato.antiguo && contrato.destino")
							.form-group
								label(for="Comentarios") Comentarios
								textarea.form-control(v-model="contrato.comentarios" rows="5" placeholder="Escribe los comentarios que consideres necesarios")
						// CONTRATOS ANTIGUOS DESGLOSE POR SOPORTES
						.alert.alert-info(style="border-radius: 0;" v-if="contrato.cliente && contrato.antiguo && contrato.destino")
							b Contrato antiguo
							p A continuación tienes el desglose de pagos.
							p
								| Este es un contrato creado con la herramienta anterior, por lo que no es posible obtener un desglose por líneas.
							p En su lugar te mostramos un detalle de los pagos por soporte y mes
						.table-responsive(v-if="contrato.antiguo")
							table.table.table-striped
								thead
									tr
										th Fecha
										th Soporte
										th Importe
								tbody
									tr(v-for="pago in contrato.pagosAntiguos")
										td {{meses[pago.mes]}} de {{pago.ano}}
										td {{pago.nombreSoporte}}
										td {{pago.importe | currency('€')}}
						.card-footer
							button.btn.btn-sm.btn-primary(type="button" @click="guardar()" v-if="contratoValido && !contrato.antiguo") Guardar
							button.btn.btn-sm.btn-primary(type="button" disabled="" v-if="!contratoValido && !contrato.antiguo") Faltan cantidades por facturar
							button.btn.btn-sm.btn-dark(v-if="!contrato.antiguo && contrato.destino" @click="setRepartirTodo()") Repartir todo
							button.btn.btn-info.btn-sm(disabled="" v-if="contrato.antiguo")
								| Los contratos antiguos no se pueden editar
				editar-facturacion(:datos="facturacion" :cliente="infoCliente" v-if="facturacion" @cerrar="cerrarFacturacion()")
			repartir-todos(:contrato.sync="contrato" :cliente="infoCliente" @cerrar="verRepartirTodo = false" v-if="verRepartirTodo")
</template>

<script>
import EditarFacturacion from './editar-facturacion'
import RepartirTodos from './repartirImportes'
import API from '../../services/api'
import { mapGetters } from 'vuex'

export default {
	props: ['idContrato'],
	components: {
		'editar-facturacion': EditarFacturacion,
		'repartir-todos': RepartirTodos
	},

	/**
	 * Cuando se crea el componente ya hacemos la petición para descargarnos el listado de soportes
	 * @return {[type]} [description]
	 */
	created: function () {
		// obtenemos los destinos
		API.getDestinos()
			.then(res => {
				this.listadoDestinos = res.data.destinos
			})
			.catch(e => {
				this.error = e.data.error || 'Error desconocido'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
			})

		// Obtenemos el cierre
		API.getCierre()
			.then(res => {
				this.cerrado.ano = parseInt(res.data.cierre.ano)
				this.cerrado.mes = parseInt(res.data.cierre.mes)
			})
			.catch(e => {
				this.error = e.data.error || 'Error desconocido'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
			})

		API.getSoportes()
			.then(res => {
				this.listadoSoportes = res.data.soportes

				for (let i = 0; i < res.data.soportes.length; i++) {
					const sop = res.data.soportes[i]
					this.soportesRAW.set(sop.ID_soporte, sop)
				}

				// También buscamos las partidas
				API.getPartidas()
					.then(res => {
						this.listadoPartidas = res.data.partidas

						// También buscamos los eventos
						API.getEventos()
							.then(res => {
								this.listadoEventos = res.data.eventos

								if (this.idContrato !== 'nuevo') {
									API.getContrato(this.idContrato)
										.then(res => {
											this.contrato = res.data.contrato

											this.contrato.fecha_inicio = new Date(this.contrato.fecha_inicio)
											this.contrato.fecha_fin = new Date(this.contrato.fecha_fin)

											// Obtenemos la info del cliente
											API.getCliente(this.contrato.cliente)
												.then(res => {
													this.infoCliente = res.data.cliente
												})
												.catch(e => {
													this.$store.commit('toast/danger', {
														titulo: 'Error',
														mensaje: e.response.data.error
													})
												})
										})
										.catch(e => {
											this.error = e.data.error || 'Error desconocido'
											this.$store.commit('alertas/alert', {
												titulo: 'Error',
												mensaje: this.error
											})
										})
								} else {
									this.contrato.agente = this.usuario.ID
									this.contrato.nombreAgente = this.usuario.nombre
								}
							})
							.catch(e => {
								this.error = e.data.error || 'Error desconocido'
								this.$store.commit('alertas/alert', {
									titulo: 'Error',
									mensaje: this.error
								})
							})
					})
					.catch(e => {
						this.error = e.data.error || 'Error desconocido'
						this.$store.commit('alertas/alert', {
							titulo: 'Error',
							mensaje: this.error
						})
					})
			})
			.catch(e => {
				this.error = e.data.error || 'Error desconocido'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
			})
	},

	data: function () {
		return {
			contrato: {
				agente: null,
				nombreAgente: null,
				cliente: null,
				nombreCliente: null,
				destino: null,
				nombreDestino: null,
				intermediario: null,
				dto_global: 0,
				intermediarioNombre: null,
				titulo: null,
				fecha_inicio: null,
				fecha_fin: null,
				partida: null,
				evento: null,
				comentarios: null,
				lineas: [],
				lineasConceptos: []
			},
			listadoPartidas: [],
			listadoEventos: [],
			listadoSoportes: [],
			listadoDestinos: [],
			listadoProductos: {},
			listadoTarifas: {},
			soportesRAW: new Map(),
			productosRAW: new Map(),
			tarifasRAW: new Map(),
			facturacion: null,
			sinAgente: false,
			meses: ['', 'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
			cerrado: {
				ano: 4000,
				mes: 1
			},
			error: 'Error desconocido',
			datosUsuario: {
				nombre: '',
				avatar: ''
			},
			infoCliente: null,
			verRepartirTodo: false,
			creandoIntermediario: false,
			nuevoIntermediario: ''
		}
	},

	computed: {
		contratoValido () {
			let descuadre = 0

			for (let i = 0; i < this.contrato.lineas.length; i++) {
				descuadre += this.calculaPagos(this.contrato.lineas[i])
			}

			for (let i = 0; i < this.contrato.lineasConceptos.length; i++) {
				descuadre += this.calculaPagos(this.contrato.lineasConceptos[i])
			}

			return descuadre === 0
		},
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},

	methods: {
		alertaAntiguo () {
			this.$store.commit('alertas/alert', {
				titulo: 'Atención',
				mensaje: `Este es un contrato antiguo y no fue creado con esta herramienta\n
						Es por ello que no es posible ver el desglose de facturación por líneas\n
						En su lugar podrás ver la planificación de facturación por soporte`
			})
		},

		setDestino (ev) {
			this.contrato.destino = parseInt(ev.target.value)

			for (let i = 0; i < this.listadoDestinos.length; i++) {
				if (parseInt(this.listadoDestinos[i].ID_destino) === this.contrato.destino) {
					this.contrato.nombreDestino = this.listadoDestinos[i].nombre
					return
				}
			}

			this.contrato.nombreDestino = null
		},

		seleccionaSoporte (linea, ev) {
			const soporte = JSON.parse(ev.target.value)
			linea.soporte = soporte.ID_soporte
			linea.nombreSoporte = soporte.soporte

			this.buscaProductos(null, soporte.ID_soporte)
		},

		seleccionaProducto (linea, ev) {
			const producto = JSON.parse(ev.target.value)
			linea.producto = producto.ID_producto
			linea.nombreProducto = producto.nombre
			this.buscaTarifas(null, linea.producto)
		},

		seleccionaIntermediario (datos) {
			this.contrato.intermediario = datos.datos.ID_intermediario
			this.contrato.intermediarioNombre = datos.datos.nombre
		},

		crearIntermediario (crear) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Crear intermediario',
				mensaje: `¿Quieres crear el intermediario "${this.nuevoIntermediario}"?`,
				callback: (acepta) => {
					if (!acepta) {
						return
					}

					const datos = {
						nombre: this.nuevoIntermediario
					}

					API.setIntermediario(datos)
						.then(res => {
							this.contrato.intermediario = res.data.ID_intermediario
							this.contrato.intermediarioNombre = res.data.nombre
							this.creandoIntermediario = false
							this.nuevoIntermediario = ''
						})
						.catch(e => {
							this.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: e.response.data.error
							})
						})
				}
			})
		},

		seleccionaTarifa (linea, ev) {
			const tarifa = JSON.parse(ev.target.value)
			linea.tarifa = tarifa.ID_tarifa
			linea.precio_unitario = tarifa.precio_unitario
			linea.duracion = tarifa.duracion
			linea.unidades = tarifa.unidades
		},

		seleccionaTarifaNueva (linea, ev) {
			linea.soporte = ev.datos.ID_soporte
			linea.producto = ev.datos.ID_producto
			linea.tarifa = ev.datos.ID_tarifa
			linea.precio_unitario = ev.datos.precio_unitario
			linea.duracion = ev.datos.duracion
			linea.unidades = 1
			linea.cantidad = 0
			linea.importe = 0
			linea.descuento = null
			linea.descuentoForzado = null
			linea.precio_trucado = null
			linea.tipo = 'radio'
			linea.descripcion = ev.datos.titulo
			linea.pagos = []
		},

		quitaTarifa (linea) {
			linea.tarifa = null
			linea.unidades = null
			linea.duracion = null
			linea.cantidad = null
			linea.descuento = null
			linea.precio_trucado = null

			this.buscaTarifas(null, linea.producto)
		},
		quitaProducto (linea) {
			linea.producto = null
			linea.nombreProducto = null
			linea.tarifa = null
			linea.unidades = null
			linea.duracion = null
			linea.cantidad = null
			linea.descuento = null
			linea.precio_trucado = null

			this.buscaProductos(null, linea.soporte)
		},

		quitaSoporte (linea) {
			linea.soporte = null
			linea.nombreSoporte = null
			linea.producto = null
			linea.nombreProducto = null
			linea.tarifa = null
			linea.unidades = null
			linea.duracion = null
			linea.cantidad = null
			linea.descuento = null
			linea.precio_trucado = null
		},
		quitaLinea (index, linea) {
			// Comprobamos que la línea no tenga pagos en periodo cerrado
			for (let i = 0; i < linea.pagos.length; i++) {
				const p = linea.pagos[i]

				const dateCerrado = new Date(this.cerrado.ano, this.cerrado.mes, 1, 0, 0, 0, 0).getTime()
				const datePago = new Date(p.ano, p.mes, 1, 0, 0, 0, 0).getTime()

				if (dateCerrado >= datePago) {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: 'No se puede eliminar esta línea porque contiene pagos en periodo de facturación cerrado'
					})
					return
				}
			}

			if (linea.tipo === 'radio') {
				this.contrato.lineas.splice(index, 1)
			} else {
				this.contrato.lineasConceptos.splice(index, 1)
			}
		},

		/**
		 * Cuando se selecciona un soporte, se verifica si ya tenemos los productos en la caché,
		 * en caso contrario, los descargamos
		 * @param  {[type]} ev [description]
		 * @return {[type]}	[description]
		 */
		buscaProductos (ev, idSoporte) {
			const ID = (ev !== null) ? ev.target.value : idSoporte

			if (Array.isArray(this.listadoProductos[ID])) {
				return
			}
			API.getProductos(ID)
				.then(res => {
					this.listadoProductos[ID] = res.data.productos

					for (let i = 0; i < res.data.productos.length; i++) {
						const prod = res.data.productos[i]
						this.productosRAW.set(prod.ID_producto, prod)
					}

					this.$forceUpdate()
				})
				.catch(e => {
					this.error = e.data.error || 'Error desconocido'
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: this.error
					})
				})
		},

		/**
		 * Cuando se selecciona un producto, se verifica si ya tenemos sus tarifas en la caché,
		 * en caso contrario, las descargamos
		 * @param  {[type]} ev [description]
		 * @return {[type]}	[description]
		 */
		buscaTarifas (ev, idProducto) {
			const ID = (ev !== null) ? ev.target.value : idProducto

			if (Array.isArray(this.listadoTarifas[ID])) {
				return
			}
			API.getTarifas(ID)
				.then(res => {
					this.listadoTarifas[ID] = res.data.tarifas

					for (let ano in res.data.tarifas) {
						const tarifas = res.data.tarifas[ano]

						for (let i = 0; i < tarifas.length; i++) {
							this.tarifasRAW.set(tarifas[i].ID_tarifa, tarifas[i])
						}
					}
					this.$forceUpdate()
				})
				.catch(e => {
					this.error = e.data.error || 'Error desconocido'
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: this.error
					})
				})
		},

		/**
		 * Método para calcular el importe de la línea
		 * @param  {[type]} linea [description]
		 * @return {[type]}	   [description]
		 */
		getImporte (linea) {
			let precioOriginal = null
			if (!linea.precio_unitario && !linea.duracion) {
				const tarifa = this.tarifasRAW.get(linea.tarifa)

				if (!tarifa) {
					return 0
				}

				precioOriginal = tarifa.precio_unitario * tarifa.duracion * linea.cantidad
			} else {
				precioOriginal = linea.precio_unitario * linea.duracion * linea.cantidad
			}

			if (linea.precio_trucado !== null && linea.precio_trucado !== '' && linea.precio_trucado !== 0) {
				// Calculamos el descuento
				linea.descuentoForzado = 100 - Math.round((linea.precio_trucado * 100 / precioOriginal))
				linea.descuento = 0

				linea.importe = linea.precio_trucado

				if (typeof this.contrato.dto_global === 'number' && this.contrato.dto_global > 0) {
					return linea.precio_trucado - (linea.precio_trucado * this.contrato.dto_global / 100)
				} else {
					return linea.precio_trucado
				}
			}

			// vemos la tarifa
			const precioFinal = precioOriginal - (precioOriginal * linea.descuento / 100)
			linea.importe = precioFinal

			if (typeof this.contrato.dto_global === 'number' && this.contrato.dto_global > 0) {
				return precioFinal - (precioFinal * this.contrato.dto_global / 100)
			} else {
				return precioFinal
			}
		},

		getImporteConcepto (item) {
			if (!item.precio_unitario) {
				return 0
			}

			if (item.precio_trucado !== null && item.precio_trucado !== '') {
				return item.precio_trucado
			}

			item.importe = (item.precio_unitario * item.cantidad) - (item.descuento * item.precio_unitario * item.cantidad / 100)

			return item.importe
		},
		calculaDescuentoConcepto (item) {
			if (!item.precio_unitario || !item.cantidad) {
				return 0
			}

			return 100 - ((item.precio_trucado * 100) / (item.precio_unitario * item.cantidad))
		},

		calculaPagos (linea) {
			let acum = 0

			for (let i = 0; i < linea.pagos.length; i++) {
				if (typeof linea.pagos[i].importe === 'number') {
					acum += linea.pagos[i].importe
				}
			}

			const dif = (typeof this.contrato.dto_global === 'number' && this.contrato.dto_global > 0) ? linea.importe - acum - (linea.importe * this.contrato.dto_global / 100) : linea.importe - acum

			return this.roundNumber(dif, 2)
		},

		abrirFacturacion (tipo, linea) {
			const datos = {
				tipo: tipo,
				soporte: linea.nombreSoporte,
				tarifa: linea.duracion + ' ' + linea.unidades,
				producto: linea.nombreProducto,
				linea: linea,
				contrato: this.contrato
			}

			this.facturacion = datos
		},

		cerrarFacturacion () {
			this.facturacion = null
		},

		setRepartirTodo () {
			this.verRepartirTodo = true
		},

		seleccionaAgente (agente) {
			this.contrato.agente = agente.datos.ID
			this.contrato.nombreAgente = agente.datos.nombre
		},

		cambiaAgente () {
			this.contrato.agente = null
			this.contrato.nombreAgente = null
		},

		seleccionaCliente (cliente) {
			this.contrato.cliente = cliente.datos.ID
			this.contrato.nombreCliente = cliente.datos.cliente
			API.getCliente(cliente.datos.ID)
				.then(res => {
					this.infoCliente = res.data.cliente
				})
				.catch(e => {
					this.$store.commit('toast/error', {
						titulo: 'Error',
						mensaje: 'Error obteniendo el cliente'
					})
				})
		},

		cambiaCliente () {
			this.contrato.cliente = null
			this.contrato.nombreCliente = null
			this.infoCliente = null
		},

		nuevaLinea () {
			this.contrato.lineas.push({
				soporte: null,
				producto: null,
				tarifa: null,
				cantidad: 0,
				importe: null,
				descuento: null,
				descuentoForzado: null,
				precio_trucado: null,
				tipo: 'radio',
				pagos: []
			})
		},

		nuevoConcepto () {
			this.contrato.lineasConceptos.push({
				ID: null,
				concepto: '',
				soporte: null,
				precio_unitario: null,
				importe: null,
				cantidad: 0,
				descuento: 0,
				precio_trucado: null,
				tipo: 'otros',
				pagos: []
			})
		},

		formatoFecha (date) {
			const ano = date.getFullYear()
			let mes = date.getMonth() + 1
			let dia = date.getDate()

			mes = (mes < 10) ? '0' + mes : mes
			dia = (dia < 10) ? '0' + dia : dia

			return dia + '/' + mes + '/' + ano
		},

		guardar () {
			if (!this.contrato.destino) {
				this.error = 'Debes especificar el destino de facturacion'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
				return
			}

			if (!this.contrato.titulo) {
				this.error = 'Por favor escribe el título del contrato'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
				return
			}

			if (!this.contrato.fecha_inicio) {
				this.error = 'Debes especificar la fecha de inicio'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
				return
			}

			if (!this.contrato.fecha_fin) {
				this.error = 'Debes especificar la fecha de fin'
				this.$store.commit('alertas/alert', {
					titulo: 'Error',
					mensaje: this.error
				})
				return
			}

			const datos = JSON.parse(JSON.stringify(this.contrato))
			datos.fecha_fin = Math.round(this.contrato.fecha_fin.getTime() / 1000)
			datos.fecha_inicio = Math.round(this.contrato.fecha_inicio.getTime() / 1000)

			if (this.contrato.estado === 2) {
				if (!confirm('Este contrato ya está aprobado.\nSi lo modificas pasará a estado de pre-aprobación')) {
					return
				}
			}

			API.setContrato(datos)
				.then(res => {
					this.contrato = res.data.contrato
					this.contrato.fecha_inicio = new Date(this.contrato.fecha_inicio)
					this.contrato.fecha_fin = new Date(this.contrato.fecha_fin)
					this.$store.commit('alertas/alert', {
						titulo: 'Contrato guardado',
						mensaje: 'Se ha guardado el contrato correctamente'
					})
				})
				.catch(e => {
					this.error = e.data.error || 'Error desconocido'
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: this.error
					})
				})
		},
		cerrar () {
			this.$emit('cerrar')
		},
		roundNumber (num, scale) {
			return _.round(num, scale)
		}
	}
}
</script>

<style lang="css">
	.filaGris {
		padding: 10px;
		position:relative;
		display: block;
		background-color: #f9f9f9;
	}

	.contieneLineasTarifas {
		display: flex;
		flex-direction: column;
		flex: 1 1;
		align-items: stretch;
	}

	.lineaTarifa {
		display: flex;
		position: relative;
		flex-direction: row;
		flex: 1 1;
		align-items: flex-start;
		align-content: flex-start;
		flex-wrap: nowrap;
		box-sizing: border-box;
		margin-top: 2px;
	}

	.celdaDescripcion {
		box-sizing: border-box;
		padding: 3px;
		flex: 1 0;		
	}
	.celdaCantidad {
		box-sizing: border-box;
		padding: 3px;
		flex: 1 0;
		min-width: 70px;
		max-width: 70px;
	}
	.celdaDto {
		box-sizing: border-box;
		padding: 3px;
		flex: 1 0;
		min-width: 70px;
		max-width: 70px;
	}
	.celdaForzado {
		box-sizing: border-box;
		padding: 3px;
		flex: 1 0;
		min-width: 70px;
		max-width: 70px;
	}
	.celdaImporte {
		box-sizing: border-box;
		padding: 3px;
		flex: 1 0;
		min-width: 100px;
		max-width: 100px;
		text-align:right;
	}
	.celdaDistribuir {
		box-sizing: border-box;
		padding: 3px;
		flex: 1 0;
		min-width: 100px;
		max-width: 100px;
		text-align:right;
	}


</style>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/listado/editor.vue